import * as axios from 'axios';

const headers = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };
};

const instance = () =>
  axios.create({
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });

//#region dictionary api
export const getDictionary = () => {
  return fetch(`/api/dictionary`, {
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};
//#endregion

//#region login api
export const submitLogin = (data) => {
  return fetch(`/api/login`, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const UploadDocument = async (body) => {
  return axios
    .create({ headers: { Pragma: 'no-cache' } })
    .post(`/api/file/Upload`, body)
    .then((res) => res.data);
};

export const saveFileToDisk = async (body) => {
  return axios
    .create({ headers: { Pragma: 'no-cache' } })
    .post(`/api/file/saveToDisk`, body)
    .then((res) => res.data);
};

export const saveEditedFileStudents = async (body) => {
  return axios
    .create({ headers: { Pragma: 'no-cache' } })
    .post(`/api/file/saveEditedStudents`, body)
    .then((res) => res.data);
};

export const getExcelFileTemplate = async () => {
  return axios
    .create({ headers: { Pragma: 'no-cache' }, responseType: 'blob' })
    .get(`/api/file/Excel`)
    .then((res) => res.data);
};

export const getWordFileTemplate = async () => {
  return axios
    .create({ headers: { Pragma: 'no-cache' }, responseType: 'blob' })
    .get(`/api/file/Word`)
    .then((res) => res.data);
};

export const isLoginExist = (value) => {
  return fetch(`/api/user/isloginexist?id=${value}`, {
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};
//#endregion

//#region roles and tasks api
export const getRoles = () => {
  return fetch('/api/controlpanel/getRoles', {
    method: 'get',
    headers: headers(),
  });
};

export const getRoleTasks = (roleId) => {
  return fetch(`/api/controlpanel/getRoleTasks?roleId=${roleId}`, {
    method: 'get',
    headers: headers(),
  });
};

export const getTasks = () => {
  return fetch(`/api/controlpanel/getTasks`, {
    method: 'get',
    headers: headers(),
  });
};

export const getUserTasks = (id) => {
  return fetch(`/api/user/userTasks?userId=${id}`, {
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};

export const setRoleTasks = (data) => {
  return fetch(`/api/controlpanel/bindTaskToRole`, {
    method: 'post',
    headers: headers(),
    body: JSON.stringify(data),
  });
};

export const createRole = (data) => {
  return fetch(`/api/controlpanel/createRole`, {
    method: 'post',
    headers: headers(),
    body: JSON.stringify(data),
  });
};

export const updateRole = (data) => {
  return fetch(`/api/controlpanel/updateRole`, {
    method: 'post',
    headers: headers(),
    body: JSON.stringify(data),
  });
};
//#endregion

//#region students api
export const getStudents = () => {
  return instance().get('/api/Students');
};

export const getStudentsWithClass = () => {
  return instance().get('api/Students/GetStudentsWithClass');
};

export const getStudentsByInstitutionId = (id) => {
  return instance().get(`api/Students/GetStudentsByInstitutionId/${id}`);
};

export const getStudentsList = () => {
  return instance().get('/api/Students');
};

export const getStudentsWithoutClasses = () => {
  return instance().get('/api/Students/GetStudentsWithoutClasses');
};

export const getInstitutionStudentsWithoutClasses = (id) => {
  return instance().get(`/api/Students/GetInstitutionStudentsWithoutClasses/${id}`);
};

export const GetStudentsWithoutClassesId = () => {
  return instance().get('/api/Students/GetStudentsWithoutClassesId');
};

export const getStudentsProfile = () => {
  return instance().get('/api/Students/Profile');
};

export const getClassStudents = (insId, id) => {
  return instance().get(`/api/students/classStudents/${insId}/${id}`);
};

export const getUnBindStudents = (insId) => {
  return instance().get(`/api/students/unBindStudents/${insId}`);
};

export const createStudents = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Students`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateStudent = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Students`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteStudent = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Students/delete/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const bindStudentsToSubject = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/Students/bindStudents', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getStudentExamsList = () => {
  return instance().get(`/api/students/exams`);
};

export const getStudentsListByGroupId = (groupId) => {
  return instance().get(`/api/students?groupId=${groupId}`);
};

export const getInstitutionByTypeId = (id) => {
  return instance().get(`/api/institutions/byTypeId/${id}`);
};

export const getRegisteredStudentsCountByInstitutionId = (institutionId) => {
  return instance().get(`/api/Students/GetRegisteredStudentsCountByInstitutionId/${institutionId}`);
};

//#endregion

//#region institution api
export const saveInstitution = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post('/api/Institutions', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const saveChangePassword = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/user/changePassword', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateInstitution = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/Institutions', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteInstitution = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/Institutions/delete', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getInstitutions = () => {
  return instance().get('/api/Institutions');
};

export const getInstitutionById = (id) => {
  return instance().get(`/api/Institutions/${id}`);
};

export const getInstitutionsType = () => {
  return instance().get('/api/InstitutionTypes');
};

export const getInstitutionByName = (name) => {
  return instance().get(`/api/Institutions/GetInstitutionByName?name=${name}`);
};

export const getInstitutionByToken = () => {
  return instance().get(`/api/Institutions/GetInstitutionByToken`);
};

//#endregion

//#region languagesType api
export const getLanguagesType = () => {
  return instance().get('/api/Languages');
};
//#endregion

//#region payment api
export const getPaymentsTypes = () => {
  return instance().get('/api/PaymentTypes');
};
//#endregion

//#region subscriptions type api
export const getSubscriptionsTypes = () => {
  return instance().get('/api/SubscriptionsType');
};
//#endregion

//#region teachers api
export const getTeachersWithoutClasses = () => {
  return instance().get('/api/Teachers/GetTeachersWithoutClasses');
};

export const getTeachersWithoutClassesId = () => {
  return instance().get('/api/Teachers/GetTeachersWithoutClassesId');
};

export const getInstitutionTeachersWithoutClasses = (id) => {
  return instance().get(`/api/Teachers/GetInstitutionTeachersWithoutClasses/${id}`);
};

export const getTeacherExamsList = () => {
  return instance().get(`/api/teachers/exams`);
};

export const getTeacherQuestionsA = () => {
  return instance().get(`/api/teachers/questionsA`);
};

export const getTeacherQuestionsB = () => {
  return instance().get(`/api/teachers/questionsB`);
};

export const createTeacher = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Teachers`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateTeacher = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Teachers`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateTeachersRange = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Teachers/UpdateTeachersRange`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTeachers = () => {
  return instance().get('/api/Teachers');
};

export const getTeachersProfile = () => {
  return instance().get('/api/Teachers/Profile');
};

export const getTeacherSubjects = () => {
  return instance().get('/api/Teachers/TeacherSubjects');
};

export const getTeacherSubjectsById = (teacherId) => {
  return instance().get(`/api/Teachers/TeacherSubjects/${teacherId}`);
};

export const getTeacherById = (id) => {
  return instance().get(`/api/Teachers/${id}`);
};

export const getTeacherByClassId = (id) => {
  return instance().get(`/api/Teachers/Class/${id}`);
};

export const getTeachersByInstitutionId = (id) => {
  return instance().get(`/api/Teachers/GetByInstitutionId/${id}`);
};

export const deleteTeachers = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/Teachers/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};
//#endregion

//#region subjects api
export const createSubjects = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/InstitutionSubjects`, [data])
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateSubjects = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/InstitutionSubjects/UpdateInstitutionSubject`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteSubjects = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/InstitutionSubjects/Delete/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSubjects = () => {
  return instance().get(`/api/InstitutionSubjects`);
};

export const getFilteredSubjects = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/InstitutionSubjects/filteredSubjects`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTeachersSubjects = () => {
  return instance().get(`/api/InstitutionSubjects/getTeachersSubjects`);
};

export const getTeachersSubjectsById = (id) => {
  return instance().get(`/api/InstitutionSubjects/getTeachersSubjectsById/${id}`);
};

export const getSubjectsWithIntitutionId = () => {
  return instance().get(`/api/InstitutionSubjects/getSubjectsWithIntitutionId`);
};

export const getInstitutionSubjectsById = (id) => {
  return instance().get(`/api/InstitutionSubjects/GetInstitutionSubjectsById/${id}`);
};

export const GetSubject = (id) => {
  return instance().get(`/api/InstitutionSubjects/GetInstitutionSubjectById/${id}`);
};

export const getSubjectsById = (id) => {
  return instance().get(`/api/InstitutionSubjects/${id}`);
};

export const FilterSubjectByInstitutionId = (id) => {
  return instance().get(`/api/InstitutionSubjects/FilterSubjectByInstitutionId/${id}`);
};

export const bindSubjectsToTeacher = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/Teachers/bindSubject', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const unbindSubjectsToTeacher = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/Teachers/unbindSubject', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const bindTopicsToSubject = (id, data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/InstitutionSubjects/bindTopicToSubject/${id}`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const unBindTopicsToSubject = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/InstitutionSubjects/unBindTopicToSubject`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSubjectTopic = (id, subId) => {
  return instance().get(`/api/topics/subjectTopics/${id}/${subId}`);
};

export const getUnBindTopics = (id) => {
  return instance().get(`/api/topics/unBindTopics/${id}`);
};

//#endregion

//#region authorized persons api
export const getAuthorizedPersons = () => {
  return instance().get('/api/AuthorizedPersons');
};

export const getAuthorizedPersonsProfile = () => {
  return instance().get('/api/AuthorizedPersons/Profile');
};

export const getAuthorizedPersonsByInstitutionId = (institutionId) => {
  return instance().get(
    `/api/AuthorizedPersons/GetAuthorizedPersonsByInstitutionId/${institutionId}`,
  );
};

export const createAuthorizedPersons = (data) => {
  return fetch(`/api/AuthorizedPersons`, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const saveAuthorizedPersons = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post('/api/AuthorizedPersons', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateAuthorizedPersons = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put('/api/AuthorizedPersons', data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteAuthorizedPersons = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/AuthorizedPersons/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAuthorizedPersonByUserId = () => {
  return instance().get(`/api/AuthorizedPersons/GetAuthorizedPersonByUserId`);
};

//#endregion

//#region topics api
export const getTopics = () => {
  return instance().get(`/api/Topics`);
};

export const getTopicsById = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Topics/allTopics`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTopicsBySubjectId = (id) => {
  return instance().get(`/api/Topics/GetTopicsBySubjectId/${id}`);
};

export const getQuestionsByTopicId = (id) => {
  return instance().get(`/api/Questions/GetQuestionsByTopicId/${id}`);
};

export const createTopics = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Topics`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const SubjectTopic = (id) => {
  return instance().get(`/api/topics/subjectTopic/${id}`);
};

export const getUser = (id) => {
  return instance().get(`/api/user?id=${id}`);
};

export const getUserRole = () => {
  return instance().get(`/api/user/GetUserRole`);
};

export const getUsers = () => {
  return instance().get('/api/user/userMain');
};

export const getLoggedUser = () => {
  return instance().get('/api/user/GetLoggedUser');
};

export const updateTopics = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Topics`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteTopics = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/Topics/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};
//#endregion

//#region classes api
export const getClasses = () => {
  return instance().get('/api/Classes');
};
export const getUnbinedClassesByInstitutionId = (id) => {
  return instance().get(`/api/Classes/GetUnbinedClassesByInstitutionId/${id}`);
};

export const FilterClassesByInstitutionId = (id) => {
  return instance().get(`/api/Classes/FilterClassesByInstitutionId/${id}`);
};

export const GetClassesWithStudentsByInstitutionId = (id) => {
  return instance().get(`/api/Classes/GetClassesWithStudentsByInstitutionId/${id}`);
};

export const getClass = (id) => {
  return instance().get(`/api/Classes/${id}`);
};

export const getInstitutionClasses = (id) => {
  return instance().get(`/api/Classes/GetClassesByInstitutionId/${id}`);
};

export const createClasses = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Classes`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const changeActive = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Classes/changeActive`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateClasses = (id, data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Classes/updateClass/${id || ''}`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteClass = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/Classes/${id || ''}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const bindStudentToClass = (id, data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Classes/bindStudentToClass/${id}`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const unBindStudentToClass = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Classes/unBindStudentToClass`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getClassesWithIntitutionId = () => {
  return instance().get(`/api/Classes/GetClassesWithIntitutionId`);
};

//#endregion

//#region questionTypes api
export const getQuestionTypes = () => {
  return instance().get('/api/QuestionTypes');
};

//#endregion

//#region questions api
export const createQuestions = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/Questions`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateQuestion = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Questions`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteQuestion = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/Questions/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadQuestionFiles = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/QuestionFiles`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const createAnswersVariants = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/QuestionAnswerVariants/files`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getQuestionsLevelsCounts = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Questions/GetQuestionsLevelsCounts`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

//#endregion

//#region questionsA api

export const createQuestionsA = (data) => {
  return fetch('/api/QuestionsA', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: headers(),
  });
};

//#endregion

//#region questionsB api

export const createQuestionsB = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/QuestionsB/file`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getQuestionsByKeyAndId = (key, id) => {
  return instance().get(`/api/Students/questions?key=${key}&id=${id}`);
};

export const getQuestionsById = (id) => {
  return instance().get(`/api/questions/${id}`);
};

export const getQuestionByIdWithOutAnswer = (id, examId) => {
  return instance().get(`/api/questions/get/${id}/${examId}`);
};

export const getAllQuestionsById = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/questions/allQuestions`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getQuestionsFile = (id) => {
  return instance().get(`/api/QuestionsB/getFile/${id}`);
};

//#endregion

//#region questionLevels api
export const getQuestionLevels = () => {
  return instance().get('/api/QuestionLevels');
};

//#endregion

//#region groups api
export const getGroupById = (id) => {
  return instance().get(`/api/Groups/GetGroupById/${id}`);
};

export const createGroups = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Groups`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateGroup = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Groups`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const unBindStudentFromGroup = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/studentGroups/unBindStudentFromGroup`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const bindStudentToGroup = (id, data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/studentGroups/bindStudentToGroup/${id}`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getGroupStudents = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .get(`/api/studentGroups/GetGroupStudents/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getStudentsToBindGroup = () => {
  return new Promise((resolve, reject) => {
    instance()
      .get(`/api/studentGroups/GetStudents`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteGroup = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/groups/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getGroupsWithTeacherId = () => {
  return instance().get(`/api/Groups/GetGroupsWithTeacherId`);
};

export const getGroupsWithStudentId = () => {
  return instance().get(`/api/Groups/GetGroupsWithStudentId`);
};

export const getGroupsWithTeacher = (id) => {
  return instance().get(`/api/Groups/GetGroupsWithTeacher/${id}`);
};

//#endregion

//#region studentGroups api
export const createStudentGroups = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/StudentGroups`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getGroups = () => {
  return instance().get('api/Groups');
};

export const getGroupStudentsCount = (subjectId) => {
  return instance().get(`api/StudentGroups/GetGroupStudentsCount/${subjectId}`);
};
//#endregion

//#region exams api
export const createExam = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/Exams`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateExam = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Exams`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const finishExam = (examId) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/Exams/finishExam/${examId}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteExam = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .delete(`/api/Exams/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getExamsAsTeacher = () => {
  return instance().get('/api/Exams/myExamsAsTeacher');
};

export const getTeacherExamsByFilter = ({ groupId, subjectId }) => {
  return instance().get(`/api/Exams/myFilteredExamsAsTeacher/${groupId}/${subjectId}`);
};

export const getStudentExamsByFilter = (groupId) => {
  console.log('assss', groupId);
  return instance().get(`/api/Exams/myFilteredExamsAsStudent/${groupId}`);
};

export const getTeacherExamsByFilterAvg = ({ groupId, subjectId }) => {
  return instance().get(`/api/StudentExams/average/${groupId}/${subjectId}`);
};

export const getTeacherExamsByFilterAvgById = ({ groupId, subjectId, teacherId }) => {
  return instance().get(
    `/api/StudentExams/averageByTeacherId/${groupId}/${subjectId}/${teacherId}`,
  );
};

export const startExam = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`api/Exams/DistributeVariants/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const checkAnswers = (id) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`api/Exams/CheckAnswers/${id}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getExams = (id) => {
  return instance().get(`/api/Exams/${id}`);
};

export const getStudentAllAnswers = (studentExamId, data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`api/StudentAnswers/getStudentAllAnswers/${studentExamId}`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const getFilteredTeacherExams = (groupId, subjectId) => {
  return instance().get(`/api/Exams/GetFilteredTeacherExams/${groupId}/${subjectId}`);
};

export const getFilteredExams = (id) => {
  return instance().get(`/api/StudentExams/filteredExams/${id}`);
};

export const getFilteredMoreExams = (id) => {
  return instance().get(`/api/StudentExams/filteredMoreExams/${id}`);
};

export const getFilteredMoreExamsById = ({ id, teacherId }) => {
  return instance().get(`/api/StudentExams/filteredMoreExamsByTeacherId/${id}/${teacherId}`);
};

//#endregion

//#region examResults
export const getStudentExams = () => {
  return instance().get(`/api/studentExams`);
};

export const getPassedExams = (groupId, subjectId) => {
  return instance().get(`/api/Exams/passedExams/${groupId}/${subjectId}`);
};

export const getPassedStudentExams = (examId) => {
  return instance().get(`/api/studentExams/passedExams/${examId}`);
};

export const getStudentAnswers = (studentExamId, questionId) => {
  return instance().get(`/api/studentAnswers/getStudentAnswers/${studentExamId}/${questionId}`);
};

export const getTeacherGroups = () => {
  return instance().get('/api/teachers/teacherGroups');
};

export const teacherSubjects = () => {
  return instance().get('/api/teachers/teacherSubjects');
};

export const getTeacherStudentsExamResults = (id) => {
  return instance().get(`/api/examResults/students/${id}`);
};

export const getExamQuestions = (id) => {
  return instance().get(`/api/studentExams/questions/${id}`);
};
export const setStartExam = (request) => {
  return instance().put(`/api/studentExams`, request);
};

export const getStudentsExamResults = (examId) => {
  return instance().get(`/api/examResults/students/${examId}`);
};

export const setExamsResults = (examResultId, studentAnswer) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/examResults/setExamsResults/${examResultId}`, studentAnswer)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const setQuestionAnswer = (studentExamId, questionId, usedHint, studentAnswer) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/StudentAnswers/${studentExamId}/${questionId}/${usedHint ?? 0}`, studentAnswer)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const setCheckedAnswer = (studentAnswer) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/StudentAnswers`, studentAnswer)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const collectTotal = (studentExamId) => {
  return new Promise((resolve, reject) => {
    instance()
      .post(`/api/studentExams/collectTotal/${studentExamId}`)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateExamsResults = (examResultId, studentAnswer) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/examResults/updateExamQuestion/${examResultId}`, studentAnswer)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};

export const putExamAnswers = (data) => {
  return new Promise((resolve, reject) => {
    instance()
      .put(`/api/examResults`, data)
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error);
      });
  });
};
//#endregion
